var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('layout-default',[(_vm._isDesktop && _vm.$route.query.type === 'live')?_c('div',{staticClass:"live-logo"},[_c('img',{attrs:{"src":`${_vm.publicPath}assets/images/TREBEL-logo.svg`,"alt":""}}),_c('span',{staticClass:"presenta-label"},[_vm._v("PRESENTA")])]):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }